import { Group, RingProgress, Stack, Text } from "@mantine/core";
import type { GenericFoodRating } from "@passio/api-client";

/** Criteria offered as one-click examples for `genericFoodRating`. */
export const GOAL_PRESETS = [
  "Is this a good choice for someone managing type 2 diabetes?",
  "Does this fit a keto diet?",
  "Is this good for muscle gain?",
  "Is this kid-friendly for a school lunchbox?",
  "Is this heart-healthy (low sodium, low saturated fat)?",
];

export const goalColor = (r?: number) => (r === undefined ? "gray" : r >= 7 ? "lime" : r >= 4 ? "yellow" : "red");

/** `genericFoodRating` result: 0-10 fit for the criterion, plus the reasoning. */
export function GoalRatingResult({ data, criterion, size = 120 }: { data: GenericFoodRating; criterion?: string; size?: number }) {
  const r = data.rating;
  return (
    <Group align="flex-start" gap="md" wrap="nowrap">
      <RingProgress
        size={size}
        thickness={size / 10}
        roundCaps
        sections={[{ value: ((r ?? 0) / 10) * 100, color: goalColor(r) }]}
        label={
          <Stack gap={0} align="center">
            <Text fz={size / 4} fw={800} lh={1}>
              {r ?? "–"}
            </Text>
            <Text fz="xs" c="dimmed">
              of 10
            </Text>
          </Stack>
        }
        style={{ flex: "none" }}
      />
      <Stack gap={4} style={{ minWidth: 0 }}>
        {criterion && (
          <Text fz="sm" fw={650}>
            {criterion}
          </Text>
        )}
        <Text fz="xs" c="dimmed">
          0 = a poor fit · 10 = a great fit
        </Text>
        {data.chainOfThought && (
          <Text fz="sm" style={{ whiteSpace: "pre-wrap" }}>
            {data.chainOfThought}
          </Text>
        )}
      </Stack>
    </Group>
  );
}
